/**
 * 環境に応じたプレフィックスを取得する
 * @returns {string} 環境プレフィックス
 */
export const getEnvironmentPrefix = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '【localhost】';
  }

  if (hostname.startsWith('dev-') || hostname.includes('-dev')) {
    return '【Dev】';
  }

  if (hostname.startsWith('demo-') || hostname.includes('-demo')) {
    return '【Demo】';
  }

  return '';
};
